
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setOrgReportData,
  setOrgReportLoading,
  setOrgReportError,
  clearOrgReport
} from '../../../features/reports/orgReportSlice';
import { useOrgReportApiMutation } from '../../../features/reports/orgReportApi';
import ActionPieChart from '../../../components/Charts/ActionPieChart';
import { Box, Card, CardActionArea, Skeleton, Typography } from '@mui/material';
import ChartsSkeleton from '../../../components/Skeleton/ChartsSkeleton';
import DateRangePick from '../../../components/Date/DateRangePick';
import PrimaryTable from '../../../components/Table/PrimaryTable';
import OrgCreditReportColumns from '../../../components/TableHeader/OrgCreditReportColumns';
import SimpleTable from '../../../components/Table/SimpleTable';
import { endOfDay, format, startOfDay } from 'date-fns';
import MultipleTagSelect from '../../../components/Elements/MultipleTagSelect';

const Organization = () => {
      const dispatch = useDispatch();
          const columns = OrgCreditReportColumns();

          const [creditTags, setCreditTags] = useState(['Credit Lead']);

          const today = new Date();
      
      const { data,totalRowCount ,loading, error } = useSelector((state) => state.orgReport);


      const [range, setRange] = useState({ from: today, to: today });


      console.warn(range,"range")
      const [getOrgCreditReport] = useOrgReportApiMutation();
      
      const formatDateOnly = (date) => {
        return new Date(date).toISOString().split('T')[0]; // "YYYY-MM-DD"
      };
          
      const fetchData = async ({ pagination, sorting, columnFilters, globalFilter, creditTags: tagFilter = creditTags }) => {
               if (!range?.from || !range?.to) {
                  return;
                }
               
                const formattedFromDate = format(startOfDay(range.from), 'yyyy-MM-dd');
                const formattedToDate = format(endOfDay(range.to), 'yyyy-MM-dd');

                  dispatch(setOrgReportLoading(true));
                  dispatch(setOrgReportError(null));
                  try {
                    const res = await getOrgCreditReport({
                      pageIndex: pagination?.pageIndex,
                      pageSize: pagination?.pageSize,
                      sorting,
                      columnFilters,
                      globalFilter,
                      data: {from : formattedFromDate, to: formattedToDate, creditTags: tagFilter,} }).unwrap();
                    dispatch(setOrgReportData(res?.data));
                  } catch (err) {
                    dispatch(setOrgReportError(err?.data?.message || 'Failed to fetch report'));
                  } finally {
                    dispatch(setOrgReportLoading(false));
                  }
      };
          
    useEffect(() => {
      fetchData({
        pagination: { pageIndex: 0, pageSize: 100 },
        sorting: [],
        columnFilters: [],
        globalFilter: ''
      });
  
      return () => {
        dispatch(clearOrgReport());
      };
    }, []);
     

    console.warn(data,"data")
      return (
            <Box>
            <Typography variant="h6" sx={{ mx: 4,my: 2, fontWeight: 'bold' }}>Organization Report</Typography>
            {loading && <ChartsSkeleton />}
            {error && <p>Something Went Wrong {error}</p>}

            

          
                  <Card sx={{ p:1,mx:4 }}>
                     {/* <CardActionArea> */}
                        

                        <Box sx={{my:2,display: 'flex',justifyContent: 'space-between',flexWrap: 'wrap',}}>

                            <Box  sx={{
      width: {
        xs: '100%', // Mobile
        sm: '100%', // Tablets
        md: '55%',  // Desktop
      },
      mb: { xs: 2, md: 0 }, // spacing below on small screens
    }}>
                                  <Box sx={{display: 'flex',mb:2}}>
                                   <Box  sx={{
      width: {
        xs: '100%',
        sm: '100%',
        md: '40%',
      },
      mr: {md : 2}
    }}>

                                    <DateRangePick
                                        range={range} setRange={setRange} fetch={() => { fetchData({
                                          pagination: { pageIndex: 0, pageSize: 100 },
                                          sorting: [],
                                          columnFilters: [],
                                          globalFilter: ''
                                        }) } }
                                    />
                                   </Box>
                                   <Box sx={{width: '60%'}}>
                                    <MultipleTagSelect
                                      label="Filters"
                                      options={['Credit Lead', 'Disbursed Lead']}
                                      value={creditTags}
                                      onChange={(newTags) => {
                                        setCreditTags(newTags); 
                                        fetchData({
                                          pagination: { pageIndex: 0, pageSize: 100 },
                                          sorting: [],
                                          columnFilters: [],
                                          globalFilter: '',
                                          creditTags: newTags, 
                                        });
                                      }}
                                      multiple={false}
                                    />
                                    </Box>

                                  </Box>
                                      
                              {data?.totalRowCount > 0 && (

                                <PrimaryTable
                                                                                           columns={columns}
                                                                                           data={data?.orgReport}
                                                                                           isLoading={loading}
                                                                                           totalRowCount={totalRowCount}
                                                                                           fetchData={fetchData}
                                                                                           sx={{maxHeight: '52vh'}}
                                />
                              )}

                            </Box>
                            
                            
                          {data?.totalRowCount > 0 && (

                            <Box  sx={{display: 'grid'}}>
                              
                                 <ActionPieChart Data={data?.orgCredit}/> 
                                 <SimpleTable
                                    title="Organization Overall"
                                    data={
                                      data?.orgCredit &&
                                      Object.entries(data.orgCredit)
                                        .filter(([_, val]) => val.loanAmtApprv > 0)
                                        .map(([orgName, val]) => ({
                                          orgName,
                                          ...val
                                        }))
                                    }
                                    columns={[
                                      { key: 'orgName', label: 'Organization', align: 'center' },
                                      { key: 'loanAmtApprv', label: 'Loan Amount', align: 'center' },
                                      { key: 'adfee', label: 'Admin Fees', align: 'center' },
                                      { key: 'gsfee', label: 'GST Fees', align: 'center' },
                                      { key: 'tled', label: 'No Of Credit', align: 'center' }
                                    ]}
                                    totalData={data?.orgCreditTotal}
                                  />
                            </Box>

                          )}
                            

                        </Box>

                        {/* <pre className="bg-gray-100 p-3 rounded">
                {JSON.stringify(data, null, 2)}
              </pre> */}
                      {/* </CardActionArea> */}
                  </Card>
              
          </Box>
      );
}
    


export default Organization;
